import { render, staticRenderFns } from "./StudyDetails.vue?vue&type=template&id=6ed89770&scoped=true"
import script from "./StudyDetails.vue?vue&type=script&lang=js"
export * from "./StudyDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ed89770",
  null
  
)

export default component.exports